import './App.scss'

import React, { Suspense } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Home from './components/Home';
import Loader from './components/Loader';
import Menu from './components/Menu';
import Header from './template/Header';
import Footer from './template/Footer';
import Galeria from './components/Galeria';
import Reserva from './components/Reserva';
import Eventos from './components/Eventos';

import { createTheme , ThemeProvider } from '@mui/material/styles';
import TermosCondicoes from './components/TermosCondicoes';
import Contacto from './components/Contacto';
import { SnackbarProvider } from 'notistack';
import StructuredData from './components/StructuredData';

// Import i18n configuration
import './locales/i18n';

const theme = createTheme(
  {
    palette: {
      primary: { main: '#7e7b5e' },
    },
  },
);


const App = () => {
  return (
    <HelmetProvider>
    <ThemeProvider theme={theme}>
    <div id="wrapper">
    <Suspense fallback={<Loader />}>
    <StructuredData />
    <Router>
    <Header />
    <SnackbarProvider>
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route exact path="/menu" element={<Menu />} />
        <Route exact path="/gallery" element={<Galeria />} />
        <Route exact path="/events" element={<Eventos />} />
        <Route exact path="/reservations" element={<Reserva />} />
        <Route exact path="/contacts" element={<Contacto />} />
        <Route exact path="/terms-and-conditions" element={<TermosCondicoes />} />
      </Routes>
    </SnackbarProvider>

    </Router>
    <Footer /></Suspense>
    </div>
    </ThemeProvider>
    </HelmetProvider>
  );
};
export default App;